export default [
	{
		ageGroup: 'Senior',
		productName: 'Skipass Kombi',
		price: 1485,
		id: '31870',
		value: '1',
		startDate: '2021-01-04',
		endDate: '',
		displayLength: '5 Dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-01-04',
		length: '5 Dagar',
		qty: '1',
		pricecode: '',
		poollid: 3187,
		priceWithInsurance: 0,
		keynumber: '',
		fromAge: 65,
		toAge: 99,
		levels: [],
		image:
			'http://static.r360online.se/klappen/images/06f185020ad57cf798b4e07e5c6e0901_org.jpg',
		periodOfValidity: 'måndag 4 jan 2021 till fredag 8 jan 2021',
		groupName: '',
		startTime: '',
		endTime: '',
		isPackage: false,
		insurance: false,
		comment: ''
	},
	{
		ageGroup: 'Ungdom',
		productName: 'Spårknapp',
		price: 65,
		id: '29200',
		value: '1',
		startDate: '2021-02-01',
		endDate: '',
		displayLength: '1 Dag',
		addrlid: '',
		detlid: '',
		begindate: '2021-02-01',
		length: '1 Dag',
		qty: '1',
		pricecode: '',
		poollid: 2920,
		priceWithInsurance: 0,
		keynumber: '',
		fromAge: 8,
		toAge: 15,
		levels: [],
		image:
			'http://static.r360online.se/klappen/images/b9b2bc6705719cc40145abde46fc9f9d_org.jpg',
		periodOfValidity: 'måndag 1 feb 2021',
		groupName: '',
		startTime: '',
		endTime: '',
		isPackage: false,
		insurance: false,
		comment: ''
	}
]
